// All Database I/O here. This is because I augment the returned data
// from the server to include calculated flags. 
//
// For a Task, I add a bucketName.

import { list, getUrl, remove } from 'aws-amplify/storage';


// TODO: I named my functions create/retrieve/update/delete, which conflict with
// Amplify's auto-generated names for graphql, so I import with "as". Is there
// a better way?
import { 
    updateTaskPogoItem as APIUpdateItem, 
    createTaskPogoItem as APICreateItem, 
    deleteTaskPogoItem as APIDeleteItem,
    deleteTaskPogoTask as APIDeleteTask, 
    createTaskPogoTask as APICreateTask, 
    createTaskPogoCompletedTask as APICreateCompletedTask,
    updateTaskPogoCompletedTask as APIUpdateCompletedTask,
    deleteTaskPogoCompletedTask as APIDeleteCompletedTask,
    createTaskPogoEmailSubscription as APICreateEmailSubscription,
    updateTaskPogoEmailSubscription as APIUpdateEmailSubscription,
    deleteTaskPogoEmailSubscription as APIDeleteEmailSubscription
} from '../graphql/mutations.js';

import { 
  getTaskPogoItemCounter, 
  getTaskPogoTask, 
  listTaskPogoTasks as APIListTaskPogoTasks, 
  completedTasksByItemId,
  getTaskPogoCompletedTask as APIGetCompletedTask
} from '../graphql/queries.js';

import { urlForItemStorage } from '../fleet-shared/Urls.mjs';
import { updateTaskBucketName, updateTaskBucketNameInTaskList, counterFromId, createCounterMapFromItem } from '../fleet-shared/TaskBuckets.mjs';
import { trimmedStringOrNull, databaseDateTimeString, copyOnlyKnownFields } from '../fleet-shared/Common.mjs';
import { taskFields} from '../fleet-shared/TaskFields.mjs';
import { itemFields } from '../fleet-shared/ItemFields.mjs';
import { emailFields } from '../fleet-shared/Email.mjs';

import { testMode } from '../App.jsx';

import { generateClient } from 'aws-amplify/api';
export const client = generateClient();


// TODO: Remove for production
// Set to true to spoof the database for testing.
const testCompletedTask = '{"id":"7eabbc91-5aaa-4cf1-8ab1-c32fb3398676","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","date":"2023-11-08","itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52","taskId":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","description":null,"taskNotes":null,"dueCounter":1900,"dueDate":null,"counterInterval":100,"daysInterval":null,"notes":null,"counter":2100.1,"createdAt":"2023-11-08T20:30:33.956Z","updatedAt":"2023-11-08T20:30:33.956Z","item":{"id":"9e76ed2c-7086-452d-b22a-8441344cb2fc","name":"Craic\'n","description":"Europa","manufacturer":"Grand Banks","serialNumber":"49","partNumber":null,"location":null,"notes":null,"dateInstalled":null,"counterInstalled":null,"parentId":null,"createdAt":"2023-10-11T17:14:33.180Z","updatedAt":"2023-10-12T23:40:43.487Z","owner":"garrett","__typename":"FleetItem"},"Task":{"id":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","description":null,"notes":null,"dueCounter":1900,"dueDate":null,"counterInterval":100,"daysInterval":null,"itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52","createdAt":"2023-10-11T17:17:44.903Z","updatedAt":"2023-11-04T23:40:12.206Z","owner":"garrett","__typename":"FleetTask"},"owner":"garrett","itemCounter":{"id":"f0cf92de-05e3-4a87-8031-319b9e543f52","name":"Hours","counter":2100.1,"itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","createdAt":"2023-10-11T17:17:22.611Z","updatedAt":"2023-10-12T23:39:00.818Z","owner":"garrett","__typename":"FleetItemCounter"},"__typename":"FleetCompletedTask"}';
const testItem = '{"id":"9e76ed2c-7086-452d-b22a-8441344cb2fc","name":"Craic\'n","description":"Europa","manufacturer":"Grand Banks","serialNumber":"49","partNumber":null,"location":null,"notes":null,"dateInstalled":null,"counterInstalled":null,"parentId":null,"createdAt":"2023-10-11T17:14:33.180Z","updatedAt":"2023-10-12T23:40:43.487Z","owner":"garrett","parentItem":null,"childItems":{"items":[{"id":"7c83ac67-25ef-4696-b3ae-2da9b948ee21","name":"Port Engine"}],"nextToken":null},"tasks":{"items":[{"id":"31555c24-61d7-413e-bca6-dab3924f7984","name":"GenSet Change Oil","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","description":null,"notes":null,"dueCounter":null,"dueDate":"2023-10-13","counterInterval":null,"daysInterval":null,"itemCounterId":null},{"id":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","description":null,"notes":null,"dueCounter":1900,"dueDate":null,"counterInterval":100,"daysInterval":null,"itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52"}],"nextToken":null},"completedTasks":{"items":[{"id":"c1d6e3b8-3ff6-4308-b014-57c1de038ad4","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52","taskId":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","description":null,"taskNotes":null,"dueCounter":1900,"dueDate":null,"counterInterval":100,"daysInterval":null,"notes":null,"counter":2100.1,"date":"2023-11-04"},{"id":"4c686b96-1a7a-41c9-b6a3-68102baa3717","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52","taskId":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","description":null,"taskNotes":null,"dueCounter":1900,"dueDate":null,"counterInterval":100,"daysInterval":null,"notes":null,"counter":2100.1,"date":"2023-11-04"},{"id":"b8648ca8-5b91-4618-b31d-c171e271c46c","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52","taskId":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","description":null,"taskNotes":null,"dueCounter":1900,"dueDate":null,"counterInterval":null,"daysInterval":null,"notes":null,"counter":2100.1,"date":"2023-11-04"},{"id":"6558f740-28fb-4c3a-a2c8-a41df4e3a892","name":"GenSet Change Oil","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","itemCounterId":null,"taskId":"31555c24-61d7-413e-bca6-dab3924f7984","description":null,"taskNotes":null,"dueCounter":null,"dueDate":"2023-10-13","counterInterval":null,"daysInterval":null,"notes":null,"counter":0,"date":"2023-11-01"},{"id":"c3be65ed-22db-4c10-bf29-f85d8d8e455f","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52","taskId":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","description":null,"taskNotes":null,"dueCounter":1900,"dueDate":null,"counterInterval":null,"daysInterval":null,"notes":null,"counter":2100.1,"date":"2023-11-01"}]},"itemCounter":{"items":[{"id":"f0cf92de-05e3-4a87-8031-319b9e543f52","name":"Hours","counter":2100.1,"itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","createdAt":"2023-10-11T17:17:22.611Z","updatedAt":"2023-10-12T23:39:00.818Z"}],"nextToken":null},"emails":{"items":[{"id":"ce67571c-b08f-401f-98a7-18b874bf977f","emailType":"itemStatus","name":"Craic\'n","email":"garrett@infopogo.com","sendHourGMT":12,"itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","sendEveryDays":1,"lastSentDate":"2023-10-12T18:54:54.108Z","nextSendDate":"2023-10-13"}]}}';
// const testItems = '[{"id":"9e76ed2c-7086-452d-b22a-8441344cb2fc","name":"Craic\'n","description":"Europa","manufacturer":"Grand Banks","serialNumber":"49","partNumber":null,"location":null,"notes":null,"dateInstalled":null,"counterInstalled":null,"parentId":null,"createdAt":"2023-10-11T17:14:33.180Z","updatedAt":"2023-10-12T23:40:43.487Z","owner":"garrett","__typename":"FleetItem"}]';
const testLogbookEntry = '{"id":"c1d6e3b8-3ff6-4308-b014-57c1de038ad4","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","date":"2023-11-04","itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52","taskId":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","description":null,"taskNotes":null,"dueCounter":1900,"dueDate":null,"counterInterval":100,"daysInterval":null,"notes":null,"counter":2100.1,"createdAt":"2023-11-05T02:50:21.781Z","updatedAt":"2023-11-05T02:50:21.781Z","item":{"id":"9e76ed2c-7086-452d-b22a-8441344cb2fc","name":"Craic\'n","description":"Europa","manufacturer":"Grand Banks","serialNumber":"49","partNumber":null,"location":null,"notes":null,"dateInstalled":null,"counterInstalled":null,"parentId":null,"createdAt":"2023-10-11T17:14:33.180Z","updatedAt":"2023-10-12T23:40:43.487Z","owner":"garrett","__typename":"FleetItem"},"Task":{"id":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","description":null,"notes":null,"dueCounter":1900,"dueDate":null,"counterInterval":100,"daysInterval":null,"itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52","createdAt":"2023-10-11T17:17:44.903Z","updatedAt":"2023-11-04T23:40:12.206Z","owner":"garrett","__typename":"FleetTask"},"owner":"garrett","itemCounter":{"id":"f0cf92de-05e3-4a87-8031-319b9e543f52","name":"Hours","counter":2100.1,"itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","createdAt":"2023-10-11T17:17:22.611Z","updatedAt":"2023-10-12T23:39:00.818Z","owner":"garrett","__typename":"FleetItemCounter"},"__typename":"FleetCompletedTask"}';
const testTask = '{"id":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","description":null,"notes":null,"dueCounter":1900,"dueDate":null,"counterInterval":100,"daysInterval":null,"itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52","createdAt":"2023-10-11T17:17:44.903Z","updatedAt":"2023-11-04T23:40:12.206Z","item":{"id":"9e76ed2c-7086-452d-b22a-8441344cb2fc","name":"Craic\'n","description":"Europa","manufacturer":"Grand Banks","serialNumber":"49","partNumber":null,"location":null,"notes":null,"dateInstalled":null,"counterInstalled":null,"parentId":null,"createdAt":"2023-10-11T17:14:33.180Z","updatedAt":"2023-10-12T23:40:43.487Z","owner":"garrett","__typename":"FleetItem"},"owner":"garrett","completedTasks":{"nextToken":null,"__typename":"ModelFleetCompletedTaskConnection"},"itemCounter":{"id":"f0cf92de-05e3-4a87-8031-319b9e543f52","name":"Hours","counter":2100.1,"itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","createdAt":"2023-10-11T17:17:22.611Z","updatedAt":"2023-10-12T23:39:00.818Z","owner":"garrett","__typename":"FleetItemCounter"},"__typename":"FleetTask","bucketName":"Overdue"}';
const testTasks = '[{"id":"3f6c98d7-3ba6-48df-b36d-b4bf2a1b801a","name":"Main Oil Change","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","description":null,"notes":null,"dueCounter":1900,"dueDate":null,"counterInterval":100,"daysInterval":null,"itemCounterId":"f0cf92de-05e3-4a87-8031-319b9e543f52","createdAt":"2023-10-11T17:17:44.903Z","updatedAt":"2023-11-04T23:40:12.206Z","owner":"garrett","__typename":"FleetTask"},{"id":"31555c24-61d7-413e-bca6-dab3924f7984","name":"GenSet Change Oil","itemId":"9e76ed2c-7086-452d-b22a-8441344cb2fc","description":null,"notes":null,"dueCounter":null,"dueDate":"2023-10-13","counterInterval":null,"daysInterval":null,"itemCounterId":null,"createdAt":"2023-10-11T17:18:24.943Z","updatedAt":"2023-10-26T22:49:06.422Z","owner":"garrett","__typename":"FleetTask"}]';

export const NewItemName = 'New Item';
export const NewTaskName = 'New Task';

// Adds a new task to the Database for this item, throws on error. Returns the createTask object returned by the API.
export async function createTask(item, name = NewTaskName) {
    if (testMode) {
      let newItem = {
        name: NewTaskName, 
        itemId: '111-222-333-444', 
        priority: 0, 
        assignedEmail: '', 
        rank: 0,
        dueDate: null
      };
      return newItem;
    }

    // Add to the database
    let newTask = {
        name: name,
        itemId: item.id,
        priority: 0,
        assignedEmail: '',
        rank: new Date().getDate(),
        dueDate: null
    };

    // Note: this can throw (e.g. network or security error)
    const created = await client.graphql({ query: APICreateTask, variables: { input: newTask }});
    var task = created.data.createTaskPogoTask;

    return task;
}

// Retrieve a task from the database, note this can throw for network issues, etc.
// Parameters:
//   id - The id of the task to retrieve.
// Returns task.
export async function retrieveTask(id, item) {
    let counterMap = createCounterMapFromItem(item);

    if (testMode) {
      let testText = testTask;
      var testObj = JSON.parse(testText);
      updateTaskBucketName(testObj, counterMap);
      return testObj;
    }

    // Get the task
    var taskData = await client.graphql({ query: getTaskPogoTask, variables: { id: id } });
    const task = taskData.data.getTaskPogoTask;
    if (null == task) {
        throw new Error('Task not found');
    }

    // Put the bucket name in to the task.
    updateTaskBucketName(task, counterMap);
    return task;
}


const APIUpdateTask = /* GraphQL */ `
  mutation UpdateTaskPogoTask(
    $input: UpdateTaskPogoTaskInput!
    $condition: ModelTaskPogoTaskConditionInput
  ) {
    updateTaskPogoTask(input: $input, condition: $condition) {
      id
      name
      assignedEmail
      priority
      rank
      cost
      itemId
      description
      notes
      dueCounter
      dueDate
      counterInterval
      daysInterval
      itemCounterId
    }
  }
`;

// Update the database, note this can throw for network issues, 
// or if the task isn't quite right.
// Parameters:
//   task - The task to save to the database.
//   item - Item the task belongs to.
//   model - Optional [Tasks] the task is already in that is updated with the new task.
// Returns model with updated task.
export async function updateTask(task, item, model) {
    task.name = trimmedStringOrNull(task.name);
    if ((null == task.name) || (task.name.length === 0)) {
      throw new Error("Name required");
    }

    // If the counter interval / due are filled in, need to have
    // an itemCounterId...  Go get it (or error if none).
    if ((task.dueCounter != null) && ((task.itemCounterId == null) || (0 === task.itemCounterId.length))) {
      throw new Error("Must fill in what counter based on, if have Due Counter or Interval set");
    }

    if (testMode) { 
      return model;
    }

    // The task has some extra fields (e.g. computed taskBucket), that the
    // Database API doesn't want. So create an object with only the fields
    // the database knows about.
    let saveTask = copyOnlyKnownFields(task, taskFields);
    saveTask.id = task.id;

    // Some fields are required for the database, but not for the user.
    if (!saveTask.dueDate) {
      saveTask.dueDate = null;
    }
    if (!saveTask.assignedEmail) {
      saveTask.assignedEmail = '';
    }
    if (!saveTask.priority) {
      saveTask.priority = -1;
    }

    var save = await client.graphql({ query: APIUpdateTask, variables: {input: saveTask }});
    var newTask = save.data.updateTaskPogoTask;

    // Add calculated fields to the new task. Note the new bucket name might not
    // be the same as the old due to changes made to task.
    let counterMap = createCounterMapFromItem(item);
    updateTaskBucketName(newTask, counterMap);

    // Caller didn't pass in a model? Nothing more to do...
    if (!model) { return newTask; }

    // Update the task in the view's model.
    for (var i=0; i < model.length; i++) {
      if (newTask.id === model[i].id) {
        model[i] = newTask;
        break;
      }
    }
    return model;
}


// Update the database, note this can throw for network issues, 
// or if the task isn't  in the database.
// Parameters:
//   id - The id of the task to delete from the database.
//   model - Optional [Tasks] the task is already in that the task is removed from.
// Returns model with task removed.
export async function deleteTask(id, model) {
    if (testMode) {
      return;
    }

    // Delete on server
    await client.graphql({ query: APIDeleteTask, variables: { input: { id: id } }});

    // Caller didn't pass in a model? Nothing more to do...
    if (!model) { return null; }

    // Update model
    for (var i=0; i < model.length; i++) {
        if (id === model[i].id) {
            model.splice(i, 1); 
            break;
        }
    }
    return model;
}

// Lists all tasks for an item.
export async function listTasks(item) {
    let items;

    let counterMap = createCounterMapFromItem(item);

    if (testMode) {
      let testText = testTasks;
      var testObj = JSON.parse(testText);
      items = testObj;
    } else {
      let fetch = await client.graphql({query: APIListTaskPogoTasks, variables: { itemId: item.id }});
      items = fetch.data.listTaskPogoTasks.items;
    }

    // Add calculated fields to the tasks.
    updateTaskBucketNameInTaskList(items, counterMap);

    return items;
}



const APICreateItemCounter = /* GraphQL */ `
  mutation CreateTaskPogoItemCounter(
    $input: CreateTaskPogoItemCounterInput!
    $condition: ModelTaskPogoItemCounterConditionInput
  ) {
    createTaskPogoItemCounter(input: $input, condition: $condition) {
      id
      name
      counter
      itemId
    }
  }
`;

export async function createItemCounter(newItem) {
    if (testMode) {
      var item = newItem;
      item.id = '111-222-333-444';
      return item;
    }

    // Note: this can throw (e.g. network or security error)
    const createdCounter = await client.graphql({ query: APICreateItemCounter, variables: { input: newItem }});

    console.log(`Created counter: ${createdCounter.id}`);

    return createdCounter.data.createTaskPogoItemCounter;
}


const APIUpdateItemCounter = /* GraphQL */ `
  mutation UpdateTaskPogoItemCounter(
    $input: UpdateTaskPogoItemCounterInput!
    $condition: ModelTaskPogoItemCounterConditionInput
  ) {
    updateTaskPogoItemCounter(input: $input, condition: $condition) {
      id
      name
      counter
      itemId
    }
  }
`;
// Update the database, note this can throw for network issues, 
// or if the counter isn't quite right.
// Parameters:
//   counter - The counter to save to the database.
//   model - Optional [Counter] the counter is already in that is updated with the new counter.
// Returns model with updated counter.
export async function updateCounter(counter, model) {
    if (testMode) {
      return model;
    }

    counter.name = trimmedStringOrNull(counter.name);
    if ((null == counter.name) || (counter.name.length === 0)) {
      throw new Error("Name required");
    }

    // Go do the update on the server -- can throw!
    var updated = await client.graphql({ query: APIUpdateItemCounter, variables: {input: counter }});
    var newCounter = updated.data.updateTaskPogoItemCounter;

    // Caller didn't pass in a model? Nothing more to do...
    if (!model) { return null; }

    // Update the task in the view's model.
    for (var i=0; i < model.length; i++) {
      if (newCounter.id === model[i].id) {
        model[i] = newCounter;
        break;
      }
    }
    return model;
}


export const APIDeleteItemCounter = /* GraphQL */ `
  mutation DeleteTaskPogoItemCounter(
    $input: DeleteTaskPogoItemCounterInput!
    $condition: ModelTaskPogoItemCounterConditionInput
  ) {
    deleteTaskPogoItemCounter(input: $input, condition: $condition) {
      id
    }
  }
`;
// Update the database, note this can throw for network issues, 
// or if the task isn't  in the database.
// Parameters:
//   id - The id of the item to delete from the database.
//   model - Optional [items] the item is already in that the item is removed from.
// Returns model with item removed.
export async function deleteCounter(id, model) {
    if (testMode) {
      return;
    }

    // First see if anyone depends on the Counter. In order to do so, need to query the Counter (we didn't
    // get enough data back in our initial query to know this).
    const counterItem = await client.graphql({ query: getTaskPogoItemCounter, variables: { id: id } });
    if ((counterItem.data.getTaskPogoItemCounter.tasks) && 
       (counterItem.data.getTaskPogoItemCounter.tasks.items) && 
       (counterItem.data.getTaskPogoItemCounter.tasks.items.length > 0)) 
    {
      var itemNames = "";
      for (var i=0; i < counterItem.data.getTaskPogoItemCounter.tasks.items.length; i++) {
        if (itemNames.length > 0) {
          itemNames = itemNames + ", ";
        }
        itemNames = itemNames + counterItem.data.getTaskPogoItemCounter.tasks.items[i].name;
      }

      throw new Error(`Cannot delete - '${itemNames}' based on this counter.`)
    }

    // Delete on server
    await client.graphql({ query: APIDeleteItemCounter, variables: { input: { id: id } }});

    // Caller didn't pass in a model? Nothing more to do...
    if (!model) { return null; }

    // Update model
    for (i=0; i < model.length; i++) {
        if (id === model[i].id) {
            model.splice(i, 1); 
            break;
        }
    }
    return model;
}

const deepGetItem = /* GraphQL */ `
  query GetTaskPogoItem($id: ID!) {
    getTaskPogoItem(id: $id) {
      id
      name
      description
      manufacturer
      serialNumber
      partNumber
      location
      notes
      dateInstalled
      counterInstalled
      parentId
      createdAt
      updatedAt
      owner
      parentItem {
        id
        name
      }
      childItems {
        items {
          id
          name
        }
        nextToken
      }
      tasks {
        items {
          id
          name
          itemId
          description
          notes
          dueCounter
          dueDate
          counterInterval
          daysInterval
          itemCounterId
        }
        nextToken
      }
      completedTasks(limit: 5, sortDirection: DESC) {
        items {
          id
          name
          itemId
          itemCounterId
          taskId
          description
          taskNotes
          dueCounter
          dueDate
          counterInterval
          daysInterval
          notes
          counter
          date
        }
      }
      itemCounter {
        items {
          id
          name
          counter
          itemId
          createdAt
          updatedAt
        }
        nextToken
      }
      emails {
        items {
          id
          emailType
          name
          email
          sendHourGMT
          itemId
          sendEveryDays
          lastSentDate
          nextSendDate
        }
      }
    }
  }
`;
export async function retrieveItem(id) {
    if (testMode) {
      let testText = testItem;
      var testObj = JSON.parse(testText);
      return testObj;
    }

    var itemData = await client.graphql({ query: deepGetItem, variables: { id: id } });

    // TODO: Handle nextToken in tasks, childItems, itemCounter, etc.

    return itemData.data.getTaskPogoItem;
}


// Saves an item edited in the UI. The UI item only includes fields the user
// can edit. So, doesn't include things like the item.id. That is copied in here.
// Returns the item returned by the database. Throws on errors.
export async function saveEditedItem(newItem, oldItem) {
    let save = copyOnlyKnownFields(newItem, itemFields);
    save.id = oldItem.id;
    const savedItem = await updateItem(save);
    return savedItem;
}

export async function updateItem(item) {
    if (testMode) {
      return;
    }

    // Go do the update -- can throw!
    var updateItem = await client.graphql({ query: APIUpdateItem, variables: {input: item }});
    return updateItem.data.updateTaskPogoItem;
}

// Delete the given item and all its children.
export async function deleteItem(item) {
    if (testMode) {
      return;
    }

    // Delete any files associated with this item. This deletes files for any children,
    // too -- since storageList returns all files in a bucket and S3 has no real
    // concept of sub-directories...
    let files = await storageList(urlForItemStorage(item.id));
    for (var i=0; i < files.length; i++) {
        await storageDelete(files[i].key);
    }

    // Go through the children, retrieve a deep copy of them (so I can get at emails, children, etc),
    // and recursively delete them.
    for (i=0; i < item.childItems.items.length; i++) {
        let child = await retrieveItem(item.childItems.items[i].id);
        await deleteItem(child);
    }

    // Delete all our tasks.
    await deleteSubTasksOfItemId(item.id);

    // Delete Counter, if any
    if (item.itemCounter && item.itemCounter.items) {
        for (i=0;  i < item.itemCounter.items.length;  i++) {
            try {
                // Try to delete the Counter. If something depends on it, it won't let us.
                await deleteCounter(item.itemCounter.items[i].id);
            } catch {
                // Do nothing if not the last (deleteCounter will throw.)
                // Eventually, we should find the last guy who relies on this
                // counter and he should delete this item.
            }
        }
    }

    // Delete email subscriptions
    for (i=0; i < item.emails.items.length; i++) {
        await deleteEmailSubscription(item.emails.items[i].id);
    }

    // Delete completed tasks entries
    await deleteCompletedTasksOfItemId(item.id);

    // Finally, delete this item.
    await client.graphql({ query: APIDeleteItem, variables: { input: { id: item.id } }});
}

// Delete all tasks related to the given item ID.
export async function deleteSubTasksOfItemId(id) {
  if (testMode) {
    return;
  }

  let filter = {
    itemId: {
      eq: id
    }
  };
  const tasksData = await client.graphql({ query: APIListTaskPogoTasks, variables: { filter: filter }});
  const tasks = tasksData.data.listTaskPogoTasks.items;

  for (var i=0; i < tasks.length; i++) {
    await deleteTask(tasks[i].id);
  }
}

// Delete all logbook entries related to the given item ID.
export async function deleteCompletedTasksOfItemId(id) {
  if (testMode) {
    return;
  }

  const logbookData = await listCompletedTasks(id);

  for (var i=0; i < logbookData.length; i++) {
    await deleteCompletedTask(logbookData[i].id);
  }
}

export async function createItem(newItem) {
    if (testMode) {
      return;
    }

    if (testMode) {
      var item = newItem;
      item.id = '111-222-333-444';
      return item;
    }

    // Note: this can throw (e.g. network or security error)
    const createdItem = await client.graphql({ query: APICreateItem, variables: { input: newItem }});

    console.log(`Created item: ${createdItem.id}`);

    return createdItem.data.createTaskPogoItem;
}


export async function createCompletedTask(newCompletedTask) {
    if (testMode) {
      return;
    }

    if (testMode) {
      var item = newCompletedTask;
      item.id = '111-222-333-444';
      return item;
    }

    const created = await client.graphql({ query: APICreateCompletedTask, variables: { input: newCompletedTask }});

    console.log(`Created completed task: ${created.id}`);

    return created.data.createTaskPogoCompletedTask;
}

// Creates a completed task, showing UI while adding/errors. Calls onAdded(newTask) on success.
export async function createCompletedTaskWithUI(itemId, showText, showError, hideStatus, onAdded) {
  try {
    showText('Adding...');

    let newTask = {
      name: 'New Entry',
      date: databaseDateTimeString(new Date()),
      itemId: itemId
    };
    let savedTask = await createCompletedTask(newTask);

    console.log(`Created completed task from ui: ${savedTask.id}`);

    onAdded(savedTask);
    hideStatus();
  }
  catch (err) {
    showError(err);
  }
}

export async function retrieveCompletedTask(id) {
    if (testMode) {
      let testText = testCompletedTask;
      var testObj = JSON.parse(testText);
      return testObj;
    }

    // Get the task
    var taskData = await client.graphql({ query: APIGetCompletedTask, variables: { id: id } });
    const task = taskData.data.getTaskPogoCompletedTask;
    return task;
}

export async function updateCompletedTask(task) {
    if (testMode) {
      return;
    }

    // Go do the update -- can throw!
    var updateItem = await client.graphql({ query: APIUpdateCompletedTask, variables: {input: task }});
    return updateItem.data.updateTaskPogoCompletedTask;
}


export async function deleteCompletedTask(id) {
    if (testMode) {
      return;
    }

    const created = await client.graphql({ query: APIDeleteCompletedTask, variables: { input: { id: id } }});
    return created.data.deleteTaskPogoCompletedTask;
}


export async function listCompletedTasks(itemId) {
  if (testMode) {
    let testText = testLogbookEntry;
    var testObj = JSON.parse(testText);
    return testObj;
  }

  const { data } = await client.graphql({ query: completedTasksByItemId, variables: { itemId: itemId, sortDirection: 'DESC' }});
  return data.completedTasksByItemId.items;
}


export async function copyTaskToCompletedTasks(task, item) {
  // Pull counter value from the optional counter associated with task. Returns -1 if none.
  let counter = 0;
  if (task.itemCounterId) {
    counter = counterFromId(item, task.itemCounterId);
    if (counter === -1) {
      counter = 0;
    }
  }

  let completedTask = {
    date: databaseDateTimeString(new Date()),
    counter: counter, 
    name: task.name,
    description: task.description,
    taskNotes: task.notes,
    dueCounter: task.dueCounter,
    itemCounterId: task.itemCounterId,
    dueDate: task.dueDate,
    counterInterval: task.counterInterval,
    daysInterval: task.daysInterval,
    itemId: task.itemId,
    taskId: task.id
  };

  if (testMode) {
    return completedTask;
  }


  return await createCompletedTask(completedTask);
}

export async function createEmailSubscription(newItem) {
  if (testMode) {
    var item = newItem;
    item.id = '111-222-333-444';
    return item;
  }

  // Note: this can throw (e.g. network or security error)
  const created = await client.graphql({ query: APICreateEmailSubscription, variables: { input: newItem }});
  return created.data.createTaskPogoEmailSubscription;
}

export async function updateEmailSubscription(item) {
    if (testMode) {
      return item;
    }

    // Remove any added data by the UI.
    let save = copyOnlyKnownFields(item, emailFields);

    // Go do the update -- can throw!
    var updateItem = await client.graphql({ query: APIUpdateEmailSubscription, variables: {input: save }});
    return updateItem.data.updateTaskPogoEmailSubscription;
}

export async function deleteEmailSubscription(id) {
    if (testMode) {
      return;
    }

    const created = await client.graphql({ query: APIDeleteEmailSubscription, variables: { input: { id: id } }});
    return created.data.deleteTaskPogoEmailSubscription;
}


// ***** Storage ******

// Returns file keys from storage for the given bucket.
export async function storageList(bucket) {
  let files = await list({ 
    prefix: bucket,
    options: {
      accessLevel: 'private', 
      listAll: true
    }
  });

  return files.items;
}


// Returns a signed url (good for a counter) for the given bucket.
// Set validateObjectExistence to true if you want to make sure the
// file exists before returning the URL.
export async function storageGet(key, validateObjectExistence = false) {
    let options = {
        accessLevel: 'private' 
    };

    if (validateObjectExistence) {
      options.validateObjectExistence = true;
    }

    let url = await getUrl({
      key: key, 
      options: options
    });

    return url;
}

// Returns a Promise to delete a file from storage.
export async function storageDelete(key) {
    let res = await remove({
      key: key, 
      options: { 
        accessLevel: 'private' 
      }
    });

    return res;
}

// Adds a "name" property to a file stored in S3. Name is the key without the bucket at the beginning.
export function addNameToStorage(file, bucket) {
  if (bucket && file.key.startsWith(bucket)) {
    file.name = file.key.slice(bucket.length);
  } else {
    file.name = file.key;
  }
}

// For Storage list processing in to files/folders.
// If bucket is provided, sets a property 'name' on each file with the bucket removed.
// returns { files, folders }
export function processStorageList(response, bucket) {
  let files = [];
  let folders = new Set();
  response.forEach((res) => {
    if (res.size) {
      // console.log(res.key);
      let file = {...res};
      addNameToStorage(file, bucket);
      
      // files.push(file);
      if (res.key.startsWith(bucket) && res.key.slice(bucket.length).split('/').length < 2) {
        files.push(file);
      } else {
        // console.info(`Found a sub-folder file: ${res.key}`)
      }

      // sometimes files declare a folder with a / within then
      let possibleFolder = res.key
        .split('/')
        .slice(0, -1)
        .join('/');

      if (possibleFolder) {
        folders.add(possibleFolder);
      }
    } else {
      folders.add(res.key);
    }
  });
  return { files, folders };
}

// For Storage list processing in to nested folders.
export function processStorageListWithHierarchy(response) {
  const filesystem = {};
  // https://stackoverflow.com/questions/44759750/how-can-i-create-a-nested-object-representation-of-a-folder-structure
  const add = (source, target, item) => {
    const elements = source.split('/');
    const element = elements.shift();
    if (!element) return; // blank
    target[element] = target[element] || { __data: item }; // element;
    if (elements.length) {
      target[element] =
        typeof target[element] === 'object' ? target[element] : {};
      add(elements.join('/'), target[element], item);
    }
  };
  response.forEach((item) => add(item.key, filesystem, item));
  return filesystem;
}

